module.exports = __webpack_public_path__ + "img/fire.769b1898.jpg";